
const 	$ = jQuery;

const 	$accordion = $('.js-accordion'),
		$toggleButton = $accordion.find('.js-toggle-button'),
		$toggleContent = $accordion.find('.js-toggle-content');

function toggleAnswer(e) {
	var $clickedElem = $(e.currentTarget),
		$toggleContent =  $clickedElem.next();
	
	$clickedElem.toggleClass('is-active');
	$toggleContent.slideToggle(200);
}

function init() {
	$toggleContent.hide();
	$toggleButton.on('click', toggleAnswer);
}

init();